( function( $ ) {  //! # script loaded
	
	$( function() {  //! # DOM ready
		/*! ===== Product Galleries ===== */
		
		/**
		 * Allow thumbnails to swap gallery photo on mobile. 
		 * Theme intentionally chooses not to. See `assets/z__isProduct.js`.
		 * 
		 * 2021-08
		 */
		if ( ! isScreenSizeLarge() ) {
			$('body.product .product__images .product-gallery__main').each( function() {
				var $gallery    = $( this ),  // Flickity gallery element
					$thumbnails = $gallery
						.siblings( '.product-gallery__thumbnails' )
							.find( '.product-gallery__thumbnail' );
				// console.log( $gallery, $thumbnails );
				
				$thumbnails.on( 'click', function( event ) {
					// console.log( 'clicked', this );
					event.preventDefault();
					
					$gallery.flickity( 'select', $thumbnails.index( this ) );
				} );
			} );
		}
	} );
} )( jQuery );